module.exports = __webpack_public_path__ + "static/img/icon-code.f545ca63.png";